import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { FindLoad, FindSuccessItem, PermissionList, RolePermission, useSecondaryModal, Images } from 'utils';
import { claimPaymentActions, httpRequestsOnSuccessActions } from 'store';
import { CreateChancel, UserTextArea } from 'components';
import { resolveEraFlag } from './constants';

const ACTION_TYPE = 'MARK_REVIEWED_REMITTANCE';

const EraFlagsPanel = ({ paymentId, reasons = [], afterSuccess, onClose }) => {
    const dispatch = useDispatch();
    const [note, setNote] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const loader = FindLoad(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const canManage = RolePermission([PermissionList.CLAIM_PMT_PAY?.code]);
    const busy = submitting && !!loader?.length;

    useEffect(() => {
        if (submitting && success) {
            setSubmitting(false);
            afterSuccess?.();
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
            onClose?.();
        }
    }, [submitting, success]);

    const handleMarkReviewed = () => {
        if (!canManage || !paymentId || busy) return;
        setSubmitting(true);
        dispatch(claimPaymentActions.markReviewedRemittance([paymentId], note, paymentId));
    };

    return (
        <div className="review-remittance-panel">
            <p className="modal-header-title">Review Remittance</p>

            <div className="review-required-alert">
                <img
                    src={Images.infoCircle}
                    alt="infoCircle"
                    style={{
                        filter: 'brightness(0) saturate(100%) invert(60%) sepia(57%) saturate(5568%) hue-rotate(5deg) brightness(90%) contrast(103%)',
                    }}
                />
                <div>
                    <p className="rr-alert-title">Review required</p>
                    <p className="rr-alert-text">
                        This remittance was created automatically from an ERA and requires review before it can be marked as reviewed.
                    </p>
                </div>
            </div>

            {!!reasons?.length && (
                <div className="rr-section">
                    <p className="rr-section-label">Review reasons</p>
                    <div className="rr-reason-chips">
                        {reasons.map((reason, i) => (
                            <span className="rr-reason-chip" key={`${reason}-${i}`}>
                                <img style={{ width: 20, height: 20 }} src={Images.alertWarning} alt="needs review" />
                                {reason}
                            </span>
                        ))}
                    </div>
                </div>
            )}

            <div className="rr-section">
                <p className="rr-notes-section-label">
                    Review notes <span className="rr-optional">(Optional)</span>
                </p>

                <div>
                    <UserTextArea
                        margin={'0'}
                        name={'note'}
                        onChange={(e) => {
                            setNote(e.target.value);
                        }}
                        value={note}
                    />
                </div>
                <p className="rr-helper">You can add a reason or any details you want to keep with this remittance.</p>
            </div>

            <CreateChancel
                create="Mark Reviewed"
                chancel="Cancel"
                onCreate={handleMarkReviewed}
                onClose={onClose}
                buttonWidth="100%"
                cancelButtonWidth="100"
                loader={busy}
                disabled={!canManage}
                image={Images.eyeWhite}
            />
        </div>
    );
};


export const EraValidationFlags = ({ item, paymentId, displayId, afterSuccess, buttonClassName = '' }) => {
    const { openSecondary, closeSecondary } = useSecondaryModal();
    const needsReview = !!item?.needsReview;
    const reasons = item?.reviewReasons?.length ? item.reviewReasons : (item?.validationFlags || []).map((flag) => resolveEraFlag(flag).title);

    if (!needsReview) return null;

    const openModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openSecondary(
            <EraFlagsPanel
                paymentId={paymentId}
                displayId={displayId}
                reasons={reasons}
                afterSuccess={afterSuccess}
                onClose={closeSecondary}
            />
        );
    };

    return (
        <button
            type="button"
            className={`reset-btn-by-default`}
            onClick={openModal}
        >
            <img style={{width: 20, height: 20}} src={Images.alertWarning} alt="needs review" />
        </button>
    );
};
